import { useRouter } from 'next/router';

import { KA_SEARCH_EXPANDED_LOCALES } from '../constants';

export const useIsKnowledgeAgentSearchEnabled = () => {
  const { locale } = useRouter();

  if (KA_SEARCH_EXPANDED_LOCALES.includes(locale as string)) {
    return true;
  }

  return false;
};
